import { render, staticRenderFns } from "./PlantVarietyAnnuityWillPayList.vue?vue&type=template&id=ddcbf95e&"
import script from "./PlantVarietyAnnuityWillPayList.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyAnnuityWillPayList.vue?vue&type=script&lang=js&"
import style0 from "./PlantVarietyAnnuityWillPayList.vue?vue&type=style&index=0&id=ddcbf95e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports